// pages/Home.js
import React from 'react';
import './Button.css';

//import apiBase from '../apiBase.json';


class Button extends React.Component {
  
  constructor(props) {
    super(props);

    this._handleClick = this._handleClick.bind(this);

    this.state = {
      buttonText:this.props.text
    };

  }

  componentWillReceiveProps(newProps) {
    this.setState({
      buttonText:newProps.text
    });
  }

  render() {
    
    var buttonClasses = "";
    if (this.props.saveButton) { buttonClasses += " saveButton"; }
    if (this.props.selected) { buttonClasses += " selected"; }
    if (this.props.badge > 0) { buttonClasses += " badged"; }
    if (this.props.actionButton) { buttonClasses += " actionButton"; }

    var buttonStyles = {};
    if (this.props.noMarginAuto) { buttonStyles.margin = ".25em"; }

    return (
      <div style={this.props.style || {}} className="fieldSet">
          {this.props.label ? <div className="clearflex justify-flex-start">
            <label data-for={this.props.name}>{this.props.label}</label>
          </div> : "" }
          <button type={this.props.type} onClick={this._handleClick} className={buttonClasses} disabled={this.props.disabled ? "disabled" : false} style={buttonStyles} data-badge={this.props.badge}>{this.state.buttonText}</button>
      </div>
    );
  }

  _handleClick() {
    if (this.props.onClick) {
      this.props.onClick();
    } 
  }

}

export default Button;


// WEBPACK FOOTER //
// ./src/components/Button.js